// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"281":"cabinet","594":"about"}[chunkId] + "." + {"281":"5ddefe50","594":"85e514cc"}[chunkId] + ".css";
};